<template>
  <section class="flex margin-top-s column">
    <!-- filters -->
    <div class="flex-1 flex column w100 middle">
      <div class="flex-1 w100">
        <div class="flex end row filters-group-holder between">
          <div style="margin-right: 16px;" class="flex column no-mobile">
            <label>Atualizar</label>
            <div class="flex end w100" style="margin-top:12px">
              <div @click="forceRefreshData()" class="button secondary">
                <i class="fas fa-sync-alt"></i>
              </div>
            </div>
          </div>

          <div class="flex-1 w100 filter-item">
            <label>Buscar</label>
            <div class="flex w100">
              <input class="input" type="text" v-model="filters.data.search" />
            </div>
          </div>

          <ltk-date-picker
            class="flex-1"
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
        </div>
      </div>
    </div>

    <!-- overview -->
    <div class="flex row w100">
      <div class="flex-1 w100">
        <box-info
          class="custom-card"
          icon="fas fa-users"
          label="Total de Leads"
          tooltip=""
          :value="stats.leads"
          :money="false"
          :currency="filters.data.currency"
        >
        </box-info>
      </div>
      <div class="flex-1 w100"></div>
      <div class="flex-1 w100"></div>
    </div>

        <!-- pagination -->

    <div class="flex-1 flex row w100 middle margin-top-l">
      <div class="flex w100 end filters-groupo-holder">
        <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :click-handler="clickCallback"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
      </div>
    </div>

    <div class="flex-1 w100 margin-to-l">
      <ul>
        <li v-for="(lead, index) in leads" :key="index">
          <div class="box margin-top-m">
            <div class="box-content">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s flex middle">
                      <div class="avatar">
                        <img :src="getGravatarUrl(lead.avatar)"/>
                      </div>
                      <div class="name">
                        <p>
                          {{ lead.email | protect }}
                        </p>
                        <small>{{ lead.platform }}</small>
                      </div>
                    </div>
                    <div class="flex-2 margin-top-s">
                      <div class="flex details between">
                        <div>
                          <p>Nome</p>
                          <small v-if="lead.name">{{ lead.name }}</small>
                          <small v-else> - </small>
                        </div>
                        <div>
                          <p>Criação</p>
                          <small>{{ lead.created_at | date }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <div class="flex end">
                    <router-link
                      :to="{
                        name: 'JorneyDetailLead',
                        params: { lead_id: lead.id },
                      }"
                    >
                      <div class="button primary">Detalhes</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="isEmpty" class="box center-text margin-top-l">
        <div class="box-content">
          <p>
            Não encontramos nenhuma venda. Assim que você tiver a
            primeira venda ela vai aparecer aqui!
          </p>
        </div>
      </div>

      <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <!-- pagination -->
      <div class="flex-1 flex row w100 middle margin-top-s">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { getLeads } from "@/services/jorney.js";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

// import barChart from "@/components/charts/barChart";
import boxInfo from "@/components/boxInfo/BoxInfo";

export default {
  name: "source-sale",
  components: {
    ltkDatePicker,
    boxInfo,
  },
  data() {
    return {
      loading: false,
      filters: {
        data: {
          date: [
            moment()
              .add(-31, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          search: "",
        },
        list: {
        },
      },
      leads: [],
      totalleads: 0,
      stats: {
        leads: 0,
      },
      offset: 10,
      page: 1,
      refreshTime: 60,
      refreshInterval: null,
    };
  },
  mounted() {
    this.getLeads();
    this.refreshInterval = setInterval(
      this.getLeads,
      this.refreshTime * 1000
    );
  },
  destroyed() {
    clearInterval(this.refreshInterval);
  },
  computed: {
    isEmpty() {
      // return !this.loading && this.Trackings && this.Trackings.length === 0;
      return this.totalleads === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalleads % this.offset;
      let value = this.totalleads / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.leads = [];
        this.getLeads();
      },
    },
    page: {
      handler() {
        this.leads = [];
        this.getLeads();
      },
    },
  },
  methods: {
    getGravatarUrl(emailMd5, size = 80, defaultImage = 'mp', rating = 'g') {
      return `https://www.gravatar.com/avatar/${emailMd5}?s=${size}&d=${defaultImage}&r=${rating}`;
    },
    fn(n) {
      if (!n) return n
      return n.toFixed(2)
    },
    forceRefreshData() {
      this.getLeads();
    },
    getLeads() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        search: this.filters.data.search,
        page: this.page,
        offset: this.offset,
      };
      getLeads(params)
        .then((result) => {
          this.stats = result.stats
          this.leads = result.leads
          this.totalleads = result.total
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar jornada",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.details {
  > div {
    margin-right: 34px;
    p {
      line-height: 20px;
    }
    small {
      font-weight: 800;
    }
  }
}

.name {
  small {
    font-weight: 800;
  }
}

.profit {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
}

.pagination {
  margin: 0px !important;
}
.box-primary {
  background: var(--primary);
  color: #fff;
}

.header {
  // margin-bottom: 18px;
  font-size: 14px;
  font-weight: 800;
  background: var(--primary);
  color: #fff;
  padding: 8px 8px;
  border-radius: 4px;
}

grid-flex .box + .box,
.flex .box + .box {
  margin-left: 0px;
}

.graphs {
  .graph {
    max-width: 100%;
    max-height: 300px;
  }
}

@media screen and (max-width: 1024px) {
  .details {
    flex-direction: column;

    > div {
      margin-right: 8px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      p::after {
        content: ":";
      }
      small {
        margin-left: 8px;
      }
    }
  }
  .action {
    margin-top: 16px;
  }
}

.custom-card {
  min-width: 350px
}

.avatar {
  border-radius: 50%;
  max-width: 80px;
  min-width: 80px;
  height: 80px;
  min-height: 80px;
  max-height: 80px;
  border: 2px solid var(--primary);
  overflow: hidden;
}
.name {
  padding-left: 4px;
  padding-right: 4px;
}
</style>
